export function uiReducer(state = {}, action) {
  switch (action.type) {
    case 'SET_ZOOM_LEVEL': {
      return Object.assign({}, state, { zoomLevel: action.zoomLevel })
    }

    case 'SET_TERMINAL_PLANNER_EXPANDED': {
      return Object.assign({}, state, { terminalPlannerExpanded: action.expanded })
    }

    case 'SET_MENU_DROPDOWN_EXPANDED': {
      return Object.assign({}, state, { menuDropdownExpanded: action.expanded })
    }

    case 'SET_SCROLL_BAR_WIDTH': {
      return Object.assign({}, state, { scrollBarWidth: action.scrollBarWidth })
    }

    default:
      return state
  }
}
